module.exports = __webpack_public_path__ + "img/Video-Thumbnail.c878b61d.jpg";